export default "__VITE_ASSET__CzS6Oggu__"